import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-tender-toggle-text-btn',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './tender-toggle-text-btn.component.html',
  styleUrl: './tender-toggle-text-btn.component.scss',
})
export class TenderToggleTextBtnComponent {
  @Input() showFilters = false; // Reçoit la valeur initiale
  @Output() showFiltersChange = new EventEmitter<boolean>(); // Émet les changements

  toggleFilters() {
    this.showFilters = !this.showFilters;
    this.showFiltersChange.emit(this.showFilters); // Émet la nouvelle valeur
  }
}
